const getExisteNumeroSobre = async NumeroSobre => {
  return true;
};

const existeNumeroSobre = {
  getExisteNumeroSobre,
};

export default existeNumeroSobre;
